import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

import crudsService from "services/cruds-service";
import { useNavigate, useParams } from "react-router-dom";
import i18n from "i18n";
import LangForm from "./langForm";
import MainInfo from "./MainInfo";
import getEmptyFields from "helper/getEmptyFields";
import { useLocation } from "react-router-dom";
import MDAlert from "components/MDAlert";
import prepareNewArr from "helper/prepareNewArr";

function AddNavBarItem() {
  const { t } = i18n;
  let { pathname } = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();

  let route = id
    ? pathname.split("/")[pathname.split("/").length - 2]
    : pathname.split("/")[pathname.split("/").length - 1];
  const [parents, setParents] = useState([]);
  const [project, setProject] = useState({
    id: null,
    parent_id: null,
    sequence: 100000,
    footer: 0,
    translations: {},
  });

  const [info, setInfo] = useState({
    id: null,
    parent_id: null,
    sequence: 100000,
    footer: 0,
    translations: {},
  });

  const [linfo, setLInfo] = useState({
    translations: {},
  });

  const [notification, setNotification] = useState({
    value: false,
    color: "info",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const errorChk = {
    translations: { name: "" },
  };

  const getProjects = async () => {
    const response = await crudsService.getAllData(
      `items/${route}/${id}?fields=*,translations.*,translations.languages_code.name,translations.languages_code.code,parent_id.*,parent_id.*,parent_id.translations.*`,
    );
    // console.log(
    //   parents.filter((g) => g.id === response.data.parent_id.id)[0],
    //   response.data.parent_id.id,
    //   parents,
    // );

    setProject((prevProject) => ({
      ...prevProject,
      translations: response.data.translations.reduce((acc, translation) => {
        acc[translation.languages_code.code] = { ...translation };
        return acc;
      }, {}),
      name: response.data.translations[0]?.name,
      sequence: response.data.sequence,
      footer: response.data.footer,
      id: response.data.id,
      parent_id:
        parents.filter((g) => g.id === response.data.parent_id?.id)[0] || null,
    }));
  };

  const getNavbarItems = async () => {
    const response = await crudsService.getAllData(
      `items/navbar?fields=*,translations.name`,
    );
    setParents(prepareNewArr(response.data));
    // console.log("getNavbarItems", prepareNewArr(response.data));

    // return prepareNewArr(response.data);
  };

  //if id change (when click edit from projects page) get the project data
  useEffect(() => {
    if (!id) return;
    getProjects();
  }, [id, parents]);

  useEffect(() => {
    getNavbarItems();
  }, []);

  useEffect(() => {
    if (!project) return;
    setInfo({
      sequence: project?.sequence,
      footer: project?.footer,
      parent_id: project?.parent_id,
    });
  }, [project]);

  const changeHandler = (e, lang) => {
    if (lang) {
      setLInfo({
        translations: {
          ...linfo.translations,
          [lang]: {
            ...linfo.translations[lang],
            [e.target.name]: e.target.value,
            languages_code: lang,
          },
        },
      });
    } else {
      setInfo({
        ...info,
        [e.target.name]: e.target.value,
      });
    }
  };

  const autoSwitchChangeHandler = (name, v) => {
    console.log(name, v);

    setInfo({
      ...info,
      [name]: v,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      // const { status, ...other } = info;
      const { translations, ...other } = errorChk;

      let obj = {
        ...getEmptyFields(info, "", other),
        ...getEmptyFields(linfo.translations["ar-SA"], "ar-SA", translations),
        ...getEmptyFields(
          linfo.translations["en-US"] || { name: "" },
          "en-US",
          translations,
        ),
        ...getEmptyFields(
          linfo.translations["tr-TR"] || { name: "" },
          "tr-TR",
          translations,
        ),
      };
      const hasErrors = Object.values(obj).some((v) => v === true);
      // console.log(hasErrors, obj);

      if (hasErrors) {
        setErrors(obj);
        return; // stop
      }

      const trns = Object.values(linfo.translations);
      // return;
      if (id) {
        await crudsService.updateItem(`items/${route}/${id}`, {
          parent_id: info?.parent_id?.id || null,
          sequence: info?.sequence,
          footer: info?.footer,
          translations: trns,
        });
      } else {
        await crudsService.createItem(`items/${route}`, {
          parent_id: info?.parent_id?.id || null,
          sequence: info?.sequence,
          footer: info?.footer,
          translations: trns,
        });
      }
      getNavbarItems();
      // setNotification({
      //   value: true,
      //   color: "success",
      //   text: "تم الحفظ بنجاح",
      // });
      navigate(`/navbar`, {
        state: { value: true, text: "تم الحفظ بنجاح" },
      });

      // console.log(diff);
    } catch (err) {
      console.error(err);
      setNotification({
        value: true,
        color: "error",
        text: "حدث خطأ ما، الرجاء المحاولة مرة أخرى",
      });
    }
  };

  return (
    <DashboardLayout>
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium" color="info">
                {project?.name || t(route)}
              </MDTypography>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MDBox display="flex" justifyContent="flex-end">
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={submitHandler}
                >
                  {t("save")}
                </MDButton>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        {notification.value === true && (
          <MDAlert color={notification.color} mt="20px">
            <MDTypography variant="body2" color="white">
              {notification.text}
            </MDTypography>
          </MDAlert>
        )}
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={8}>
            <MainInfo
              changeHandler={changeHandler}
              autoSwitchChangeHandler={autoSwitchChangeHandler}
              setInfo={setInfo}
              info={info}
              setErrors={setErrors}
              errors={errors}
              notification={notification}
              setNotification={setNotification}
              parents={parents}
            />
          </Grid>
          <Grid item xs={12} lg={8}>
            <LangForm
              project={project}
              changeHandler={changeHandler}
              setInfo={setLInfo}
              info={linfo}
              notification={notification}
              setNotification={setNotification}
              errors={errors}
              setErrors={setErrors}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddNavBarItem;
